<script setup lang="ts">
import { computed, ref, onMounted, h } from 'vue';
import Dialog from 'primevue/dialog';

interface Props {
  text: string;
  maxCharacters?: number;
  classComponent: string;
}
const props = withDefaults(defineProps<Props>(), {
  maxCharacters: 200
});

const visibleReadMore = ref(false);
const separateCharacters = computed(() => {
  const margin = (props.text.match(/\n\n/g) || []).length;
  let text = props.text.slice(0, props.maxCharacters - margin);
  if (text.length < props.text.length) {
    text += '...';
  }
  return text;
});

const visibleReadmoreFunc = () => {
  visibleReadMore.value = true;
};

const isVisibleByHTML = (text: string) => {
  return text.includes('<') && (text.includes('/>') || text.includes('</'));
};

const renderSeprateCharactersHTML = () => {
  return h('div', { innerHTML: separateCharacters.value });
};

const renderTextHTML = () => {
  return h('div', { innerHTML: props.text });
};

onMounted(() => {
  document.getElementsByTagName('body')[0].classList.add('show-body');
});
</script>
<template>
  <div class="long-paragraph-component">
    <div v-if="isVisibleByHTML(props.text)" class="html-content">
      <p :class="classComponent">
        <renderSeprateCharactersHTML></renderSeprateCharactersHTML>
        <span v-if="separateCharacters.length < text.length">
          ... <a class="text-blue-600 underline cursor-pointer text-left" @click="visibleReadmoreFunc()">{{ $t('common.readmore') }}</a>
        </span>
      </p>
    </div>
    <div v-else class="text-content white-space-break">
      <p class="mb-0 pb-0" :class="classComponent">
        <renderSeprateCharactersHTML></renderSeprateCharactersHTML>
      </p>
      <p v-if="separateCharacters.length < text.length" class="text-blue-600 underline cursor-pointer text-left" @click="visibleReadmoreFunc()">{{ $t('common.readmore') }}</p>
    </div>
    <Dialog header=" " v-model:visible="visibleReadMore" :modal="true" class="tcs long-text-modal read-more-modal" :class="!isVisibleByHTML(props.text) && 'white-space-break'">
      <renderTextHTML />
    </Dialog>
  </div>
</template>
